import React, { useRef, useState } from 'react'
import { apiUrl } from 'environment'

import { useActionless } from 'redux/hooks'
import { SET_ACTIVE_STATE } from 'redux/active/actions/types'

import { searchParams } from 'utils/SearchParams'
import { getImageUrl } from 'utils/ImageUrl'

import StyledComponentThemeWrapper from 'components/misc/StyledComponentThemeWrapper'
import { HoverImage } from 'components/card/deckCards/textCardStyle'

import { generateTabState } from 'types/searchV2'

import styles from './inlineCardPreview.module.scss'

type Props = {
  name: string
  children: React.ReactNode
}

/**
 * This component is a card in the a comment, deck description, forum post, etc. It is highlighted yellow and shows a
 * card on hover.
 */
const CardLink = ({ name, children }: Props) => {
  const linkRef = useRef<HTMLSpanElement>(null)

  const [loading, setLoading] = useState(false)
  const [imgurl, setImgurl] = useState('')
  const [isHovering, setIsHovering] = useState(false)
  const [offsetLeft, setOffsetLeft] = useState(0)
  const [offsetTop, setOffsetTop] = useState(0)

  const [setActiveState] = useActionless(SET_ACTIVE_STATE)

  const getCardInDecks = () => {
    setLoading(true)

    return fetch(apiUrl + '/api/cards/latestImage/' + searchParams({ name }), {
      method: 'GET',
      headers: { Accept: 'application/json' },
    })
      .then(response => response.json())
      .then(data => setImgurl(getImageUrl(data.results[0].edition, data.results[0].uid, false)))
      .catch(err => console.error(err))
      .finally(() => setLoading(false))
  }

  const handleEnter = () => {
    if (linkRef.current) {
      setOffsetLeft(linkRef.current.offsetLeft)
      setOffsetTop(linkRef.current.offsetTop)
    }

    setIsHovering(true)

    if (!loading) getCardInDecks()
  }

  const handleLeave = () => setIsHovering(false)

  const handleCardClick = () => {
    const newSearchTab = generateTabState.archidektSearch()

    // @ts-ignore
    newSearchTab.meta.name = name
    // @ts-ignore
    newSearchTab.meta.exact = true

    setActiveState({ searchOpen: newSearchTab })
  }

  return (
    <StyledComponentThemeWrapper>
      <span
        ref={linkRef}
        className={styles.cardLink}
        spellCheck={false}
        onClick={handleCardClick}
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}>
        {children}
        {isHovering && imgurl !== '' && (
          <HoverImage
            style={{
              backgroundImage: 'url("' + imgurl + '")',
              zIndex: isHovering ? 10000 : -1,
              opacity: isHovering ? 1 : 0,
              left: offsetLeft,
              top: offsetTop,
            }}
          />
        )}
      </span>
    </StyledComponentThemeWrapper>
  )
}

export default CardLink
